// CONFIGURATION MENU DATA
export const configurationMenus = [
    {
        text: "General",
        icon: "menu",
        description: "Manage the general settings",
        permission: "",
        options: [
            // { text: "create_notification", link: "settings_create_notification", icon: "notifications", description: "Define customize notifications" },
            { text: "departments", link: "departments", icon: "account_tree", description: "Manage internal departments", permission: "" },
            { text: "distributors", link: "distributors", icon: "horizontal_distribute", description: "Manage distributors", permission: "" },
            { text: "help_articles", link: "settings_help_articles", icon: "article", description: "Manage system help articles" },
            { text: "manufacturers", link: "manufacturers", icon: "precision_manufacturing", description: "Configure manufacturers", permission: "" },
            { text: "options", link: "options_categories", icon: "list", description: "Manage options for auto complete fields", permission: "" },
            { text: "shipping_carriers", link: "shipping_carriers", icon: "local_shipping", description: "Configure shipping companies", permission: "" },
            { text: "units_of_measure", link: "units_of_measure", icon: "straighten", description: "Configure units of measure", permission: "" },
            { text: "vendors", link: "vendors", icon: "sell", description: "Configure vendors", permission: "" },
        ],
    },
    {
        text: "Devices",
        icon: "devices",
        description: "Manage the device specific settings",
        permission: "",
        options: [
            {
				text: "device_subscriptions",
				link: "device_subscriptions",
				icon: "subscriptions",
				description: "Manage device subscriptions",
				permission: "subscriptions.read",
			},
            {
                text: "firmware",
                link: "firmware_versions",
                icon: "cloud_download",
                description: "Manage firmware versions",
                permission: "",
            },
            {
                text: "sensor_types",
                link: "sensor_types",
                icon: "sensors",
                description: "Configure sensor types",
                permission: "",
            },
            {
				text: "subscription_plans",
				link: "subscription_plan",
				icon: "subscriptions",
				description: "Manage subscription plans",
				permission: "",
			},
            {
                text: "tank_manufacturers",
                link: "tank_manufacturers",
                icon: "precision_manufacturing",
                description: "Manage tank manufacturers",
                permission: "",
            },
            {
                text: "tank_types",
                link: "tank_types",
                icon: "gradient",
                description: "Confirgure tank types",
                permission: "",
            },
        ],
    },
    {
        text: "Financial",
        icon: "payments",
        description: "Manage the financial settings for your dashboard",
        permission: "",
        options: [
            { text: "bank_accounts", link: "bank_accounts", icon: "account_balance", description: "Configure Bank Accounts", permission: "" },
            { text: "chart_of_accounts", link: "chart_of_accounts", icon: "format_list_bulleted", description: "Configure Chart of Accounts", permission: "" },
            { text: "currency", link: "currencies", icon: "attach_money", description: "Configure Currency", permission: "" },
            { text: "exchange_rates", link: "exchange_rates", icon: "currency_exchange", description: "Configure Exchange Rates", permission: "" },
            { text: "payment_terms", link: "payment_terms", icon: "gavel", description: "Payment terms for customers/suppliers", permission: "" },
        ],
    },
    {
		text: "Integrations",
		icon: "hgi-solid hgi-api",
		description: "Manage third party integrations",
		permission: "",
		// This is the name of the vuex action that is used to fetch the data from the API
		fetch: "fetchOauthProviders",
		// This is the dynamic key that is used to access the data returned from the API
		fetched_data_key: "oauth_providers",
	},
    {
        text: "Security",
        icon: "lock",
        description: "Manage security for your dashboard",
        options: [
            { text: "active_sessions", link: "settings_active_sessions", icon: "bolt", description: "Quickly view and/or terminate sessions", permission: "" },
            {
                text: "api_keys",
                link: "api_keys",
                icon: "hgi hgi-solid hgi-key-01",
                description: "Manage API Keys",
                permission: "",
            },
            { text: "login_attempts", link: "settings_login_attempts", icon: "lock_clock", description: "Identify and manage login threats", permission: "" },
            {
                text: "permission_templates",
                link: "settings_permission_templates",
                icon: "edit_note",
                description: "Define custom permission templates",
                permission: "",
            },
        ],
    },
    {
        text: "Developer",
        icon: "api",
        description: "Manage core system settings",
        permission: "",
        options: [
            {
                text: "configure_environment",
                link: "settings_configure_environment",
                icon: "settings",
                description: "Manage specific settings for this device",
            },
            { text: "dashboard_widgets", link: "dashboard_widgets", icon: "widgets", description: "Manage dashboard widgets", permission: "" },
            { text: "data_import_logs", link: "data_import_logs", icon: "cloud_upload", description: "Manage data imports", permission: "" },
            { text: "form_builder", link: "settings_form_builder", icon: "post_add", description: "Manage form validation", permission: "" },
            { text: "languages", link: "settings_languages", icon: "translate", description: "Setup & configure languages", permission: "" },
            { text: "mysql", link: "settings_mysql", icon: "dns", description: "Manage database tables", permission: "" },
            { text: "notifications", link: "notifications", icon: "notifications", description: "Manage notifications", permission: "" },
            { text: "permissions", link: "settings_permissions", icon: "lock", description: "Manage base user permissions", permission: "" },
        ],
    },
];
